class APIS {
    apis() {
        return {
            getOtpProviders: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/fetch/otp-providers'
            },
            addOtpProvider: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/add/otp-provider'
            },
            updateOtpProvider: {
                headers: {
                    'xt-user-token': null
                },
                method: 'put',
                path: '/update/otp-provider'
            },
            getOtpUsers: {
                headers: {
                    'xt-user-token': null
                },
                method: 'get',
                path: '/auth/otp-users'
            },
            getAllOtpUsers: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/get/client-wise/users/otp'
            },
            getOtpUserwise: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/get/users/otp/:id'
            },
            send: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/auth/send-otp'
            },
            verify: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/auth/verify-otp'
            },
            add: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/users/otp/:id'
            },
            update: {
                headers: {
                    'xt-user-token': null
                },
                method: 'put',
                path: '/backend/users/otp/update/:id'
            },
            delete: {
                headers: {
                    'xt-user-token': null
                },
                method: 'delete',
                path: '/backend/users/otp/remove/:id'
            },
        };
    }
}

export default new APIS();
